
import  { createContext, useContext, useState } from "react";

interface OnboardingData {
  companyName: string;
  registrationNo: string;
  companyAddress: string;
  zipCode: number
}

interface OnboardingContextType {
  data: OnboardingData;
  setData: React.Dispatch<React.SetStateAction<OnboardingData>>;
  resetData: () => void;
}

const OnboardingContext = createContext<OnboardingContextType | undefined>(undefined);

export const OnboardingProvider = ({ children }: { children: React.ReactNode }) => {
  const [data, setData] = useState<OnboardingData>({
    companyName: "",
    registrationNo: "",
    companyAddress: "",
    zipCode: 0,
  });

  const resetData = () => setData({ companyName: "", registrationNo: "", companyAddress: "", zipCode: 0 });

  return (
    <OnboardingContext.Provider value={{ data, setData, resetData }}>
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error("useOnboarding must be used within an OnboardingProvider");
  }
  return context;
};
